import React from "react";
import usecasesData from "../data/usecases.json";

const Usecases = () => {
  // Use the imported JSON data directly
  const usecases = usecasesData;

  return (
    <section id="usecases" className="usecases-section">
      <div className="section-title">
        <h2>Use Cases</h2>
        <p>
          Proven AI Solutions, Real Impact. See how our custom AI systems
          transform industries, streamline operations, and drive measurable
          results.
        </p>
      </div>
      {/* Render use cases vertically */}
      <div className="usecase-container">
        {usecases.map((usecase, index) => (
          <div key={index} className="usecase-slide">
            <h3>{usecase.title}</h3>
            <h4>The Challenge</h4>
            <p>{usecase.challenge}</p>
            <h4>The Opportunity</h4>
            <p>{usecase.opportunity}</p>
            <h4>What We Delivered</h4>
            <ul>
              {usecase.solution.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <h4>Value to Our Customer</h4>
            <p>{usecase.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Usecases;